// extracted by mini-css-extract-plugin
export var container = "_70-0";
export var fallback = "_70-5";
export var fallbackIcon = "_70-6";
export var hidden = "_70-2";
export var image = "_70-3";
export var loaded = "_70-4";
export var placeholder = "_70-1";